import { ReactNode } from 'react';

import { AlertVariantT } from '@consumer-frontend/shared-ui';

export type AlertBannerPropsT = {
  dismissible: boolean;
  heading: string;
  message: ReactNode;
  show: boolean;
  variant: AlertVariantT;
};

export const initialAlertBannerProps: AlertBannerPropsT = {
  dismissible: false,
  heading: '',
  message: '',
  show: false,
  variant: 'info',
};

export type ModalConfigT = {
  body: JSX.Element | string;
  primaryText: string;
  show: boolean;
  title: string;
  modalOnClick?: () => void;
  secondaryText?: string;
};

export const initialModalConfig: ModalConfigT = {
  body: '',
  primaryText: '',
  secondaryText: '',
  show: false,
  title: '',
};

export const externalLinkModalConfig: ModalConfigT = {
  body: (
    <p>
      By clicking this link you will be leaving the NetCredit website — www.netcredit.com.
      You will be automatically directed to a website that is not directly controlled by NetCredit.
      By clicking OK, you acknowledge that you are leaving the NetCredit website.
    </p>
  ),
  primaryText: 'OK',
  secondaryText: 'Cancel',
  show: false,
  title: 'Leaving NetCredit.com',
};

export const paymentMethods = {
  BankAccountAch: 'bank_account_ach',
  PersonalCheck: 'personal_check',
} as const;

export type PaymentMethodT = typeof paymentMethods[keyof typeof paymentMethods];

export type SectionT = {
  html: string;
  name: string;
};

export type ContractT = {
  name: string;
  sections: SectionT[];
};

export type ContractsResponseT = {
  contracts: ContractT[];
};

// Draw min/max limits — seeded from props/server, not user input.
export type DrawLimitsT = {
  max: number;
  min: number;
};

export const initialDrawLimits: DrawLimitsT = {
  max: 2000,
  min: 0,
};

// DOM ids a rejected Continue can send the customer to. Shared so the element that renders the
// field and the atom that names it as the first error cannot drift apart.
export const FIELD_ANCHORS = {
  drawAmount: 'draw-amount',
  repaymentMethod: 'repayment-method',
} as const;
